import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue } from 'bootstrap-vue'
import vSelect from 'vue-select'
import VueI18n from 'vue-i18n'
import messages from './lang'
import VTooltip from 'v-tooltip'
import ScrollLoader from 'vue-scroll-loader'
import VueMeta from 'vue-meta'
import { directive as onClickaway } from 'vue-clickaway'
import { installAnalytics } from './analytics'
import { SENTRY_API } from './env'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
if (SENTRY_API) {
  // make sure sentry doesn't run locally
  Sentry.init({
    dsn: SENTRY_API,
    integrations: [new VueIntegration({ Vue, attachProps: true })]
  })
}

Vue.directive('on-clickaway', onClickaway)
Vue.use(ScrollLoader)
Vue.use(BootstrapVue)
installAnalytics(router)

Vue.component('v-select', vSelect)

var VueCookie = require('vue-cookie')

Vue.use(VueCookie)
Vue.use(VueI18n)
Vue.use(VTooltip)
Vue.use(VueMeta)
Vue.directive('tooltip', VTooltip)
export const i18n = new VueI18n({
  locale: 'de',
  fallbackLocale: 'en',
  messages
})

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
